import React, { useState } from 'react';
import Row from '@amzn/meridian/row';
import Select, { SelectOption } from '@amzn/meridian/select';
import Icon from '@amzn/meridian/icon';
import Tooltip from '@amzn/meridian/tooltip';
import infoKnockoutTokens from '@amzn/meridian-tokens/base/icon/info-knockout';
import { ERROR_COLOR } from 'src/constants/values';
import { AgileMacroplanogram } from '@components/agile/types/AgileMacroplanogramTypes';
import { AgileTableRow } from '@components/agile/types/AgileTableRow';
import { ICellRendererParams } from 'ag-grid-community';

const ZoneSelectCellRenderer = (
  params: ICellRendererParams & {
    data: AgileTableRow;
    value: string;
    macroplanogramList: AgileMacroplanogram[];
    onZoneChange: (asin: string, oldZone: string, newZone: string, rowId?: string) => void;
    includeDraft?: boolean;
  },
) => {
  const { data, value, macroplanogramList, onZoneChange, node } = params;
  const [selectedZone, setSelectedZone] = useState(value);
  const [errorFlag, setErrorFlag] = useState(value === 'Unassigned');

  const handleZoneChange = (newZoneId: string) => {
    const selectedMacroplanogram = macroplanogramList.find((zone) => zone.entryId === newZoneId);
    const newZoneName = selectedMacroplanogram?.macroplanogramName || newZoneId;
    const newMacroplanogramId = selectedMacroplanogram?.entryId || '';

    setSelectedZone(newZoneName);
    onZoneChange(data.asin, value, newZoneName, data.rowId);
    setErrorFlag(newZoneId === '');

    // Update the node data's macroplanogramId directly
    if (node) {
      node.setDataValue('macroplanogramId', newMacroplanogramId);
      node.setDataValue('zoneName', newZoneName);
    }
  };

  // Show dropdown for new ASINs or ADD actions, existing ones show as text
  if (!data.isNewAsin && data.recommendedAction !== 'ADD') {
    return <span>{value}</span>;
  }

  return (
    <Row spacing="none" spacingInset="none" maxWidth="50">
      <Select
        value={
          macroplanogramList.find((zone: AgileMacroplanogram) => zone.macroplanogramName === selectedZone)?.entryId ||
          ''
        }
        onChange={handleZoneChange}
        width={150}
        error={errorFlag}
      >
        <SelectOption value="" label="Unassigned" disabled />
        {macroplanogramList?.map((zone: AgileMacroplanogram) => (
          <SelectOption value={zone.entryId} label={zone.macroplanogramName || zone.entryId} key={zone.entryId} />
        ))}
      </Select>
      {errorFlag ? (
        <Tooltip position="end" title="Please select a zone" id="zoneTooltip">
          <Icon className={ERROR_COLOR} tokens={infoKnockoutTokens} />
        </Tooltip>
      ) : null}
    </Row>
  );
};

export default ZoneSelectCellRenderer;
